import { render, staticRenderFns } from "./AlertBaby.vue?vue&type=template&id=0196cc08"
import script from "./AlertBaby.vue?vue&type=script&lang=js"
export * from "./AlertBaby.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports